import { Grid } from '@cp/ds/src/components/grid';
import { Stack } from '@cp/ds/src/components/stack';
import { StyledListItem } from '@cp/ds/src/components/styled/styledListItem';
import { StyledUnorderedList } from '@cp/ds/src/components/styled/styledUnorderedList';
import { Typography } from '@cp/ds/src/components/typography';
import React from 'react';
import { createEventFactory, createName } from '@cp/shared/tracking';
import { SupportNavigate } from 'src/features/support/navigate';
import { SupportCallLink as SupportBaseLink } from 'src/features/support';
import { EButtonName, withTrackClick } from 'src/shared/tracking';
import { LoginButton } from 'src/features/auth';
import { SupportCode } from 'src/shared/supportCode';

const supportCallEvent = createEventFactory({
  goalId: 'nazhatie_na_nomer_telefona_v_podvale',
  goalName: 'Нажатие на номер телефона в подвале',
  name: createName('support', 'call'),
});
const SupportCallLink = withTrackClick(SupportBaseLink, supportCallEvent);

const BUTTON_MIN_WIDTH = 151;

const SupportSection: React.FC = () => {
  return (
    <Grid item sm={6} xs={12}>
      <Stack alignItems="flex-start" direction="column">
        <Typography component="h6" sx={{ color: 'brand gray', mt: 0, mb: 2.25 }} variant="button secondary">
          Cтать специалистом:
        </Typography>
        <StyledUnorderedList>
          <StyledListItem>
            <LoginButton
              className={EButtonName.RegisterAsSpecialist}
              color="pink"
              size="small"
              sx={{ minWidth: BUTTON_MIN_WIDTH }}
              variant="primary"
            >
              Регистрация
            </LoginButton>
          </StyledListItem>
        </StyledUnorderedList>
      </Stack>
      <Stack alignItems="flex-start" direction="column" sx={{ mt: { xs: 5, md: 4 } }}>
        <Typography component="h6" sx={{ color: 'brand gray', mt: 0, mb: 2.25 }} variant="button secondary">
          Служба поддержки:
        </Typography>
        <StyledUnorderedList>
          <StyledListItem>
            <SupportNavigate buttonProps={{ sx: { minWidth: BUTTON_MIN_WIDTH } }} />
          </StyledListItem>
          <StyledListItem sx={{ mb: 6, mt: 2 }}>
            <SupportCallLink />
            <SupportCode />
          </StyledListItem>
        </StyledUnorderedList>
      </Stack>
    </Grid>
  );
};

export default SupportSection;
